import React from 'react';
import CustomerReminder from './containers/CustomerReminder';
import HoursMinsSelect from './components/HoursMinsSelect';
import Row from './components/Row';
import Common from './Common';

class ShopNotificationMethods extends Common {
  renderArrived() { // eslint-disable-line
    return (
      <Row className="u-mb-" label="Arrived" action="notifications.arrived" hide={this.props.commonHiddenFields} />
    );
  }

  renderReminders() { // eslint-disable-line
    return (
      <div>
        <div className="u-mb-">
          <Row label="Reminder" action="notifications.reminder" hide={this.props.commonHiddenFields} />
          <HoursMinsSelect label="Remind:" name="notifications.reminder.time" />
        </div>
        <div className="u-mb-">
          <div className="c-label c-label--light u-pb--">Client notifications</div>
          <CustomerReminder name="customerReminder" commonHiddenFields={this.props.commonHiddenFields} />
        </div>
      </div>
    );
  }
}

export default ShopNotificationMethods;
